import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Grid, Typography, Card } from '@material-ui/core';
import warning from 'images/warning.svg';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import TutorInfoDialog from 'containers/TransactionManagerTimeLine/OfferRegulation/TutorDialog';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { translate } from 'containers/services/translate';
import { COLORS, BUTTON_COLORS } from 'constants/design';
import { requestAddTutorInfo } from 'containers/TransactionManagerTimeLine/actions';

export interface EmptyStateTutorProps {
  intl: IntlShape;
  transactionId: number;
  claimId: number;
  victimId: number | null;
}

export const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
  width: '100%',
  marginBottom: '20px',
};
export const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};
const EmptyStateTutor: React.FC<EmptyStateTutorProps> = props => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const successCallBack = () => {
    toast.success(translate(messages.successCallBackMessage, props));
    setOpenDialog(false);
  };
  const handleAddTutorInfo = (payload: any) => {
    dispatch(requestAddTutorInfo(payload, successCallBack));
  };
  return (
    <Card style={StyledCard} elevation={0}>
      <Grid
        container
        direction="row"
        justify={'space-between'}
        alignItems={'center'}
      >
        <Grid item>
          <Grid container direction="row" spacing={1} alignItems={'center'}>
            <Grid item>
              <img src={warning} alt="warning" />
            </Grid>
            <Grid item>
              <Typography style={StyledText}>
                {translate(messages.warningTitleTutor, props)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <PrimaryButton
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.addTutorButtonTitle, props)}
            onClick={() => {
              setOpenDialog(true);
            }}
          />
        </Grid>
      </Grid>
      <TutorInfoDialog
        open={openDialog}
        onClose={setOpenDialog}
        handleValidate={handleAddTutorInfo}
        transactionId={props.transactionId}
        claimId={props.claimId}
        victimId={props.victimId}
      />
    </Card>
  );
};
export default injectIntl(EmptyStateTutor);
